import { clearSession } from "./session";
/**
 * "Are you sure you want to log out?", shared by the header menu and the
 * sidebar. sweetalert2 is loaded on the click: the header and sidebar are in
 * the entry bundle, and a static import put the whole library there for a
 * question most visits never ask.
 */
export function confirmLogout(navigate) {
  return import("sweetalert2").then(({ default: Swal }) =>
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to log out?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, log me out",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) { clearSession(); navigate("/"); }
    })
  );
}
